/**
 * 销售系统 - 商户管理 - 签单表（只读：查询、分页、导出）
 */
<template>
  <div class="merchant-list-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/sales/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>签单表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="商户">
          <el-input
            v-model="formInline.merchantName"
            placeholder="请输入商户名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="formInline.providerName"
            placeholder="请输入服务商名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="签约时间">
          <el-date-picker
            v-model="signOrderDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            class="search-date-range"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="返点">
          <el-select
            v-model="formInline.hasRebate"
            placeholder="全部"
            clearable
            class="search-input"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        :loading="exportButtonLoading"
        @click="exportData"
      >导出数据</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
      >
        <el-table-column
          fixed
          prop="merchantName"
          label="商户"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span @dblclick="copyToClipboard(scope.row.merchantName)">
              {{ scope.row.merchantName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="providerName" label="服务商" show-overflow-tooltip>
          <template slot-scope="scope">
            <span @dblclick="copyToClipboard(scope.row.providerName)">
              {{ scope.row.providerName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="quotePrice" label="合同报价" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.quotePrice) }}
          </template>
        </el-table-column>
        <el-table-column prop="modifiedPrice" label="合同改价" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="price-cell" @click="showPriceHistory(scope.row, 1)">
              <span class="price-value">{{
                formatPercent(scope.row.modifiedPrice)
              }}</span>
              <i
                v-if="scope.row.lastModifiedPriceDate"
                class="el-icon-view history-icon"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="lastModifiedPriceDate"
          label="合同改价日期"
          show-overflow-tooltip
          min-width="120"
        />
        <el-table-column prop="actualQuotePrice" label="实际报价" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.actualQuotePrice) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="actualQuoteModifiedPrice"
          label="实际改价"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="price-cell" @click="showPriceHistory(scope.row, 2)">
              <span class="price-value">{{
                formatPercent(scope.row.actualQuoteModifiedPrice)
              }}</span>
              <i
                v-if="scope.row.actualQuoteModifiedPriceDate"
                class="el-icon-view history-icon"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="actualQuoteModifiedPriceDate"
          label="实际改价日期"
          show-overflow-tooltip
          min-width="120"
        />
        <el-table-column prop="rebate" label="返点" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.rebate) }}
          </template>
        </el-table-column>
        <el-table-column prop="businessType" label="业务" show-overflow-tooltip />
        <el-table-column prop="invoiceContent" label="发票内容" show-overflow-tooltip />
        <el-table-column prop="isCreateGroup" label="建群" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.isCreateGroup === 1 ? 'success' : 'danger'"
              size="small"
            >
              {{ scope.row.isCreateGroup === 1 ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="specialIndustry" label="特殊行业" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.specialIndustry === 1 ? 'success' : 'danger'"
              size="small"
            >
              {{ scope.row.specialIndustry === 1 ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="signDate" label="签约日期" show-overflow-tooltip />
        <el-table-column prop="startDate" label="启动时间" show-overflow-tooltip />
        <el-table-column
          prop="providerEnableStatus"
          label="服务商启用状态"
          show-overflow-tooltip
          min-width="120"
        >
          <template slot-scope="scope">
            <template
              v-if="
                scope.row.providerEnableStatus === 1 ||
                scope.row.providerEnableStatus === '1'
              "
            >
              <el-tag type="success" size="small">启用</el-tag>
            </template>
            <template
              v-else-if="
                scope.row.providerEnableStatus === 0 ||
                scope.row.providerEnableStatus === '0'
              "
            >
              <el-tag type="info" size="small">停用</el-tag>
            </template>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="providerDisabledDate"
          label="停用时间"
          show-overflow-tooltip
        />
        <el-table-column prop="accountStatus" label="开户" show-overflow-tooltip>
          <template slot-scope="scope">
            <i
              :class="[
                scope.row.accountStatus === 1 ? 'el-icon-check' : 'el-icon-close',
                'table-status-icon',
              ]"
              :style="{
                color: scope.row.accountStatus === 1 ? '#67c23a' : '#f56c6c',
              }"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="archiveDate" label="归档日期" show-overflow-tooltip />
        <el-table-column prop="phoneSales" label="电销" show-overflow-tooltip />
        <el-table-column prop="faceSales" label="面销" show-overflow-tooltip />
        <el-table-column prop="owner" label="渠道" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" show-overflow-tooltip />
      </el-table>

      <div class="pagination-wrap">
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </div>
    </el-card>

    <el-dialog
      :title="priceHistoryDialog.title"
      :visible.sync="priceHistoryDialog.visible"
      width="700px"
      :close-on-click-modal="false"
      custom-class="price-history-dialog"
    >
      <div
        class="price-history-container"
        v-loading="priceHistoryDialog.loading"
        element-loading-text="加载中..."
      >
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in priceHistoryList"
            :key="index"
            :timestamp="item.modifiedPriceDate"
            placement="top"
            :color="getTimelineColor(item.decreaseOrIncrease)"
          >
            <el-card shadow="hover" class="history-card">
              <div class="history-content">
                <div class="price-change">
                  <span class="old-price">{{
                    formatPercent(item.oldPrice)
                  }}</span>
                  <i class="el-icon-right change-icon"></i>
                  <span class="new-price">{{
                    formatPercent(item.newPrice)
                  }}</span>
                  <el-tag
                    size="mini"
                    :type="getChangeTypeTag(item.decreaseOrIncrease)"
                    class="change-type-tag"
                  >
                    {{ getChangeTypeText(item.decreaseOrIncrease) }}
                  </el-tag>
                </div>

                <div class="detail-item">
                  <span class="label">备注：</span>
                  <span class="value">{{ item.remark }}</span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>

        <div v-if="!priceHistoryDialog.loading && priceHistoryList.length === 0" class="empty-state">
          <i class="el-icon-tickets empty-icon"></i>
          <p class="empty-text">暂无改价历史记录</p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="priceHistoryDialog.visible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerSignOrders, getChangePriceRecords } from "../../api/userMG";
import Pagination from "../../components/Pagination";

export default {
  name: "SalesCustomerSignOrder",
  components: {
    Pagination,
  },
  data() {
    return {
      loading: false,
      exportButtonLoading: false,
      priceHistoryDialog: {
        visible: false,
        loading: false,
        title: "改价记录",
      },
      priceHistoryList: [],
      signOrderDate: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        providerName: "",
        hasRebate: "",
      },
      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    this.getdata(this.formInline);
  },
  methods: {
    showPriceHistory(row, type) {
      const params = {
        merchantId: row.merchantId,
        providerId: row.providerId,
        type: type,
      };
      this.priceHistoryDialog.title =
        type === 1 ? "合同改价记录" : "实际改价记录";
      this.priceHistoryDialog.visible = true;
      this.priceHistoryDialog.loading = true;
      this.priceHistoryList = [];

      getChangePriceRecords(params)
        .then((res) => {
          this.priceHistoryDialog.loading = false;
          if (res.msg === "success") {
            this.priceHistoryList = res.data || [];
          } else {
            this.$message.error(res.msg || "获取改价记录失败");
            this.priceHistoryList = [];
          }
        })
        .catch(() => {
          this.priceHistoryDialog.loading = false;
          this.$message.error("获取改价记录失败");
        });
    },
    getTimelineColor(changeType) {
      switch (changeType) {
        case 1:
          return "#f56c6c";
        case 2:
          return "#67c23a";
        default:
          return "#409eff";
      }
    },
    getChangeTypeTag(changeType) {
      switch (changeType) {
        case 1:
          return "danger";
        case 2:
          return "success";
        default:
          return "info";
      }
    },
    getChangeTypeText(changeType) {
      switch (changeType) {
        case 1:
          return "价格上调";
        case 2:
          return "价格下调";
        case 3:
          return "报价调整";
        default:
          return "价格调整";
      }
    },
    copyToClipboard(text) {
      const val = text == null ? "" : String(text);
      if (!val) {
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(val).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        const input = document.createElement("textarea");
        input.value = val;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === 0) {
        return "";
      }
      try {
        if (typeof value === "string" && value.includes("%")) {
          return value;
        }
        const num = parseFloat(value);
        if (isNaN(num)) {
          return "";
        }
        return (num * 100).toFixed(2) + "%";
      } catch (e) {
        return "";
      }
    },
    buildListParams(parameter) {
      return {
        page: parameter.page,
        pageSize: parameter.pageSize,
        merchantName: parameter.merchantName,
        providerName: parameter.providerName,
        hasRebate:
          parameter.hasRebate === "" ? undefined : parameter.hasRebate,
        startSignDate: this.signOrderDate[0] || "",
        endSignDate: this.signOrderDate[1] || "",
        phoneSaleName: "",
        faceSaleName: "",
        ownerName: "",
        location: "",
        export: 0,
      };
    },
    getdata(parameter) {
      this.loading = true;
      const params = this.buildListParams(parameter);
      getCustomerSignOrders(params)
        .then((res) => {
          this.loading = false;
          if (res.msg !== "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
            return;
          }
          this.listData = res.data.items;
          this.pageparm.page = res.data.page;
          this.pageparm.pageSize = res.data.pageSize;
          this.pageparm.total = res.data.totalCount;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportData() {
      this.exportButtonLoading = true;
      const params = {
        page: 1,
        pageSize: 999999999,
        merchantName: this.formInline.merchantName,
        providerName: this.formInline.providerName,
        hasRebate:
          this.formInline.hasRebate === "" ? undefined : this.formInline.hasRebate,
        startSignDate: this.signOrderDate[0] || "",
        endSignDate: this.signOrderDate[1] || "",
        phoneSaleName: "",
        faceSaleName: "",
        ownerName: "",
        location: "",
        export: 1,
      };
      getCustomerSignOrders(params)
        .then((res) => {
          this.exportButtonLoading = false;
          if (res.msg === "success") {
            if (res.data && res.data.downloadUrl) {
              window.open(res.data.downloadUrl);
            } else {
              this.$message({
                type: "error",
                message: "导出链接为空，请联系管理员",
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch(() => {
          this.exportButtonLoading = false;
        });
    },
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    search() {
      this.formInline.page = 1;
      this.getdata(this.formInline);
    },
    reset() {
      this.signOrderDate = [];
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
        providerName: "",
        hasRebate: "",
      };
      this.getdata(this.formInline);
    },
  },
};
</script>

<style scoped>
.merchant-list-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.search-form .search-date-range {
  width: 260px;
}
.toolbar {
  margin: 16px 0;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}
.table-status-icon {
  font-size: 16px;
}

.price-cell {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.price-cell:hover {
  color: #409eff;
}
.history-icon {
  margin-left: 6px;
  font-size: 14px;
}

.price-history-container {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
  min-height: 120px;
}
.price-history-dialog .el-dialog__body {
  padding: 12px 20px 8px;
}

.history-card {
  margin-bottom: 10px;
}
.history-card.el-card.is-always-shadow {
  border-color: inherit;
}
.history-content {
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.price-change {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-left: 8px;
  font-size: 16px;
  font-weight: 500;
  min-height: 32px;
}
.old-price {
  color: #f56c6c;
  text-decoration: line-through;
  margin-right: 8px;
}
.change-icon {
  margin: 0 12px;
  color: #909399;
}
.new-price {
  color: #67c23a;
  font-weight: 600;
  margin-right: 12px;
}
.change-type-tag {
  align-self: center;
}
.detail-item {
  display: flex;
  align-items: flex-start;
  margin-left: 0;
  padding-left: 0;
}
.detail-item .label {
  min-width: 50px;
  text-align: right;
  margin-right: 8px;
  color: #606266;
  white-space: nowrap;
}
.detail-item .value {
  flex: 1;
  color: #303133;
  word-break: break-word;
  line-height: 1.5;
}
.empty-state {
  text-align: center;
  padding: 40px 20px;
}
.empty-icon {
  font-size: 60px;
  color: #dcdfe6;
  margin-bottom: 16px;
}
.empty-text {
  color: #909399;
  font-size: 14px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/sales/customerSignOrder.vue